import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLanguageContext } from '@/i18n/LanguageContext';
import { benefitsRelatedPages } from '@/mocks/benefitsData';

export default function RelatedPages() {
  const { t } = useTranslation();
  const { lang } = useLanguageContext();
  return (
    <section className="relative py-20 md:py-28 bg-background-100/50">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="text-center mb-12">
          {String(t('benefits.related.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('benefits.related.title')}
          </h2>
          {String(t('benefits.related.titleEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-500 text-[15px] tracking-[0.12em] mb-4 font-label">{__s}</p>))}
          <div className="w-10 h-[1px] bg-accent-500/40 mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {benefitsRelatedPages.map((page, idx) => (
            <Link
              key={idx}
              to={page.href}
              className="card-glow group block bg-background-50 border border-background-200/60 p-5 cursor-pointer"
            >
              <h3 className="font-heading text-[16px] text-foreground-900 tracking-[0.05em] mb-2 group-hover:text-accent-600 transition-colors">
                {lang === 'en' ? t(`benefits.related.${idx}.title`) : page.title}
              </h3>
              <p className="text-[14px] text-foreground-500 tracking-[0.03em] leading-relaxed mb-3">
                {lang === 'en' ? t(`benefits.related.${idx}.desc`) : page.description}
              </p>
              <div className="flex items-center gap-2 text-accent-500 group-hover:text-accent-400 transition-colors">
                <span className="text-[13px] tracking-[0.06em]">{t('benefits.related.arrowLabel')}</span>
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-xs"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
